import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import Button from './Button';

interface ErrorScreenProps {
  title?: string;
  message?: string;
  showRetry?: boolean;
  onRetry?: () => void;
  children?: React.ReactNode;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({
  title = 'Something went wrong',
  message = 'An error occurred while loading this page.',
  showRetry = false,
  onRetry,
  children,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center px-4">
        <div className="mb-6">
          <AlertTriangle className="w-16 h-16 mx-auto text-red-500 mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
          <p className="text-gray-600">{message}</p>
        </div>

        {children && <div className="mb-6">{children}</div>}

        {showRetry && onRetry && (
          <Button
            onClick={onRetry}
            variant="primary"
            className="inline-flex items-center space-x-2"
          >
            <RefreshCw size={16} />
            <span>Try Again</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorScreen;
